// src/pages/HomePage.jsx
import React, { useRef } from 'react';
import Home from './Home';
import Equipe from './Equipe';
import Whats from '../components/Whats';
import Top from '../components/Top';
import Desk from './Desk';
import Services from './Services';
import Instagram from './Instagram';
import Contact from './Contact';
import BottomCookie from '../components/BottomCookie';

const HomePage = () => {
  const deskRef = useRef(null);

  const scrollToDesk = () => {
    if (deskRef.current) {
      deskRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Home />
      <Equipe />
      <Whats />
      <Top />
      <div ref={deskRef}>
        <Desk />
      </div>
      <Services />
      <Instagram />
      <Contact onShowDesk={scrollToDesk} />
      <BottomCookie />
    </>
  );
};

export default HomePage;
